import {list} from '../../../../../../common/classes/request-builder';
import {StorageManager} from '../../../../../../common/storage-manager.class';

import { FincasModel } from '../../../../../../models/form-common/fincas.module';
import { SectorModel } from '../../../../../../models/form-common/sector.model';
import { ParcelasModel } from '../../../../../../models/form-common/parcelas.model';
import { MantenimientoModel } from '../../../../../../models/trabajadores/mantenimiento.model';
import { MaquinariaModel } from '../../../../../../models/trabajadores/maquinaria.model';
import { TratamientosModel } from '../../../../../../models/tratamientos/tratamientos.model';
import { TareaFitoModel } from '../../../../../../models/tareas/tarea-fito.model';
import {
    DropdownData,
    DropdownFilterContext,
    FilteredValue,
    Form,
    FormField,
    FormSection,
    FormType,
    InputType,
    ReactiveFieldLogicContext,
    ReactiveFormChangedField,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';
import moment from 'moment';
import { Utils } from '../../../../../../common/utils';
import { firstValueFrom } from 'rxjs';
import { RecuperarReferenciaRecetaService } from '../../../../../../service/recuperar.service';
import { FitosanitariosEnvironmentDefinition } from '../../environment-variables';
import { FitosanitariosListsDefinition } from './list-variables';
import { Climatologia } from '../climatologia.interface';
import { WeatherService } from '../../../../../../service/api/weather/weather';
import { environment } from '../../../../../../../environments/environment';
import { signal } from '@angular/core';
import {
    createClientScopedCatalogueLegacyFilter,
    createClientScopedLegacyFilter,
    createClientScopedOptionFilter,
    createClientScopedParams,
    createFincaScopedLegacyFilter,
    createFincaScopedOptionFilter,
    createFincaScopedParams,
    createParcelasScopedLegacyFilter,
    createParcelasScopedOptionFilter,
    createTareasLocationDropdownDataSource,
    tareasLocationDependencyBehaviour,
    tareasLocationFincaDependencyBehaviour,
} from '../../../shared/tareas-location-dropdown.datasource';

export class FitosanitariosFormDefinition {
    public disabledDates: Date[] = [];

    public formType!: FormType;
    public env: FitosanitariosEnvironmentDefinition = new FitosanitariosEnvironmentDefinition();
    public lists: FitosanitariosListsDefinition = new FitosanitariosListsDefinition();

    public cliente = StorageManager.getClient();
    public usuario = StorageManager.getUser();
    public activateRequireHourForRolUser = this.env.appName === 'ava' && this.usuario.rol !== 'admin';

    public recuperarService!: RecuperarReferenciaRecetaService;
    public weatherService!: WeatherService;

    public model: ReactiveFormValue<TareaFitoModel> = {} as ReactiveFormValue<TareaFitoModel>;
    public ids_productos: string[] | undefined;
    public horaInicio = '';
    public horaFin = '';

    public referenciaReceta: string | null = null;
    private pendingReferenciaRecetaYear: number | null = null;
    public tag: ReactiveFormChangedField<TareaFitoModel> = '';

    public formFieldsHidden!: FormSection<object>;
    public formFieldsTiempo!: FormSection<object>;
    public formFieldsKM!: FormSection<object>;
    public formFieldsLugar!: FormSection<object>;
    public formFieldsTratamiento!: FormSection<object>;
    public formFieldsTractor!: FormSection<object>;
    public formFieldsInnovia!: FormSection<object>;
    public formFieldsFinal!: FormSection<object>;
    public formFieldsClima!: FormSection<object>;
    public formFieldsMezclasSobrantes!: FormSection<object>;
    public formFieldsOrdenTrabajo!: FormSection<object>;
    public formFieldsObs!: FormSection<object>;


    public formFields!: Form<TareaFitoModel>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public fieldNames: FormField<any>[] = [];
    public fieldLabels: string[] = [];

    public now = new Date();
    public day = this.now.getDate();
    public dayOfWeek = this.now.getDay();
    public month = (this.now.getMonth() + 1).toString().padStart(2, '0');
    public year = this.now.getFullYear().toString();
    public hours = this.now.getHours().toString().padStart(2, '0');
    public minutes = this.now.getMinutes().toString().padStart(2, '0');

    showDialogTratamiento = signal(false);


    constructor(type: FormType, model: Record<string,string>, table: (string[] | string[][])[]
    | null, disabledDates: Date[], private eventos: { start: string; title: string; hora_inicio: string; hora_fin: string }[]) {
        this.formType = +type;
        this.model = model;

        this.disabledDates = disabledDates;


        this.formFields = {
            name: 'fitosanitarios',
            header: 'Datos de la tarea',
            type: this.formType,
            sections: this.getFormSections(),
            table: {title: '', showIndex: false, data: table?.[0], style: table?.[1]},
            uploadButton: {
                isEnabled: false,
                label: ''
            },
            signed: this.env.showTareasMto,
            previousDataTransform: (previousData: TareaFitoModel) => this.normalizePreviousData(previousData),
        };
    }


    public setLocationDataSources(endpoints: { fincas: unknown; sectores: unknown; parcelas: unknown }): void {
        const fincaField = this.findField(this.formType < 3 ? 'id_finca' : 'finca');
        const sectorField = this.findField(this.formType < 3 ? 'id_sector' : 'sectores_nombres');
        const parcelaField = this.findField(this.formType < 3 ? 'ids_parcelas' : 'parcelas_nombres');

        if (fincaField) {
            fincaField.dataSource = createTareasLocationDropdownDataSource<TareaFitoModel, FincasModel>({
                endpoint: endpoints.fincas,
                cacheKey: 'tareas-fito-fincas',
                label: 'nombre',
                params: createClientScopedParams,
                filterOption: createClientScopedOptionFilter<TareaFitoModel>({
                    isEnabled: () => this.env.hasClients && this.formType !== FormType.EDITION && this.env.userCanSeeClientes,
                }),
            });
            fincaField.input.dropdownConfiguration = {
                ...fincaField.input.dropdownConfiguration,
                filter: createClientScopedLegacyFilter<TareaFitoModel>({
                    isEnabled: () => this.env.hasClients && this.formType !== FormType.EDITION && this.env.userCanSeeClientes,
                }),
            };
            fincaField.dependencyBehaviour = tareasLocationFincaDependencyBehaviour;
        }

        if (sectorField) {
            sectorField.dataSource = createTareasLocationDropdownDataSource<TareaFitoModel, SectorModel>({
                endpoint: endpoints.sectores,
                cacheKey: 'tareas-fito-sectores',
                label: 'nombre',
                dependsOn: ['id_finca'],
                params: createFincaScopedParams,
                filterOption: createFincaScopedOptionFilter<TareaFitoModel>(),
            });
            sectorField.input.dropdownConfiguration = {
                ...sectorField.input.dropdownConfiguration,
                filter: createFincaScopedLegacyFilter<TareaFitoModel>(),
            };
            sectorField.dependencyBehaviour = tareasLocationDependencyBehaviour;
        }

        if (parcelaField) {
            parcelaField.dataSource = createTareasLocationDropdownDataSource<TareaFitoModel, ParcelasModel>({
                endpoint: endpoints.parcelas,
                cacheKey: 'tareas-fito-parcelas',
                label: (parcela) => this.getParcelaOptionLabel(parcela),
                dependsOn: ['id_finca'],
                params: createFincaScopedParams,
                filterOption: createParcelasScopedOptionFilter<TareaFitoModel>({
                    sectorFieldName: 'id_sector',
                    isSectorFilterEnabled: () => this.env.showTareasSector,
                }),
            });
            parcelaField.input.dropdownConfiguration = {
                ...parcelaField.input.dropdownConfiguration,
                filter: createParcelasScopedLegacyFilter<TareaFitoModel>({
                    sectorFieldName: 'id_sector',
                    isSectorFilterEnabled: () => this.env.showTareasSector,
                }),
            };
            parcelaField.dependencyBehaviour = tareasLocationDependencyBehaviour;
        }
    }

    private findField(fieldName: string): FormField<TareaFitoModel> | undefined {
        return this.formFields.sections
            .flatMap((section: FormSection<TareaFitoModel>) => section.fields)
            .find((field: FormField<TareaFitoModel>) => field.name === fieldName) as FormField<TareaFitoModel> | undefined;
    }

    private getParcelaOptionLabel(parcela: ParcelasModel): string {
        if (this.env.appName === 'prosanzcu') {
            return [parcela.nombre, parcela.municipio, parcela.poligono]
                .filter((value) => value !== null && value !== undefined && String(value).trim().length > 0)
                .join(' ');
        }

        if (this.env.appName === 'avafitogest') {
            return this.getAvaFitogestParcelaOptionLabel(parcela);
        }

        return String(parcela.nombre ?? '');
    }

    private getAvaFitogestParcelaOptionLabel(parcela: ParcelasModel): string {
        const nombre = String(parcela.nombre ?? '').trim();
        const variedad = String(parcela.variedad ?? 'SIN VARIEDAD').trim() || 'SIN VARIEDAD';
        const zonaRiegoAbreviada = this.getParcelaZonaRiegoAbreviada(parcela);
        const variedadConZona = zonaRiegoAbreviada ? `${variedad} - ${zonaRiegoAbreviada}` : variedad;
        const codigos = [parcela.poligono, parcela.numero, parcela.recinto]
            .map((value) => String(value ?? '').trim())
            .filter((value) => value.length > 0)
            .join('-');
        const superficie = this.getParcelaSuperficieLabel(parcela);
        const detalle = [codigos || undefined, superficie]
            .filter((value): value is string => value !== undefined && value.length > 0)
            .join(' · ');
        const descripcion = [nombre, variedadConZona]
            .filter((value) => value.length > 0)
            .join(' - ');

        return detalle.length > 0 ? `${descripcion} — ${detalle}` : descripcion;
    }

    private getParcelaZonaRiegoAbreviada(parcela: ParcelasModel): string {
        if (String(parcela.cultivo ?? '').toLowerCase() !== 'arroz') {
            return '';
        }

        const zonaRiego = String(parcela.zona_riego ?? '').toLowerCase();

        if (zonaRiego.includes('alta')) {
            return 'ZA';
        }

        if (zonaRiego.includes('baja')) {
            return 'ZB';
        }

        return '';
    }

    private getParcelaSuperficieLabel(parcela: ParcelasModel): string {
        const superficieRaw = String(parcela.superficie_cultivada ?? parcela.superficie_sigpac ?? parcela.superficie ?? '0');
        const superficie = parseFloat(superficieRaw.replace(',', '.')) || 0;
        const superficieFormateada = superficie.toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        return `${superficieFormateada} ${this.env.textoSuperficie || 'ha'}`;
    }

    private normalizePreviousData(previousData: TareaFitoModel): TareaFitoModel {
        return {
            ...previousData,
            desplazamiento: this.normalizeIntegerDropdownValue(previousData.desplazamiento),
            mano_obra: this.normalizeDecimalDropdownValue(previousData.mano_obra),
            rpm: this.normalizeIntegerDropdownValue(previousData.rpm),
        };
    }

    private normalizeIntegerDropdownValue(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        const normalized = String(value).trim();

        if (normalized.length === 0) {
            return '';
        }

        const numericValue = Number(normalized.replace(',', '.'));

        if (!Number.isFinite(numericValue)) {
            return normalized;
        }

        return Math.trunc(numericValue).toString();
    }

    private normalizeDecimalDropdownValue(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        const normalized = String(value).trim();

        if (normalized.length === 0) {
            return '';
        }

        const numericValue = Number(normalized.replace(',', '.'));

        if (!Number.isFinite(numericValue)) {
            return normalized;
        }

        return numericValue.toString();
    }

    public getDefaultPresionValues() {
        switch (this.env.appName) {
        case 'laplana':
            return this.lists.presionLaplana;
        default:
            return this.lists.presionAll;
        }
    }

    public checkIfProductIsValid(fecha_caducidad: string) {
        const diff = moment(new Date()).diff(Utils.toDate(fecha_caducidad), 'months');

        if (diff > 12) {
            return '* ';
        } else if (diff > 6) {
            return '* ';
        } else if (diff >= 0) {
            return '* ';
        }

        return '';
    }


    private hasCurrentTratamiento(): boolean {
        const tratamientoValue = this.getModelTextValue('id_tratamiento') || this.getModelTextValue('tratamiento_nombre');

        return this.findDropdownRawValue(this.lists.tratamientos, tratamientoValue) !== null || tratamientoValue.length > 0;
    }

    private getPresionValuesForMaquinaria(maquinariaValue: unknown): DropdownData<string> {
        const maquinaria = this.findDropdownRawValue(this.lists.maquinarias, maquinariaValue) as Partial<MaquinariaModel> | null;

        switch (maquinaria?.tipo) {
        case 'Herbicida':
            return this.lists.presionHerbicida;
        case 'Turboatomizador':
            return this.lists.presionTurbo;
        case 'Disparador':
            return this.lists.presionDisparador;
        default:
            return this.lists.presionAll;
        }
    }

    getInfoProductos() {
        if (this.hasCurrentTratamiento()) {
            this.showDialogTratamiento.set(true);
        }
    }

    public getTiempoFields() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tiempoFields: FormField<any>[] = [
            {
                name: 'fecha_inicio',
                vinculatedFields: undefined,
                label: (this.env.appName === 'armentia') ?
                    'Fecha inicio' :
                    'Fecha Receta',
                input: {
                    type: InputType.CALENDAR,
                    defaultValue: (environment.features.horaFechaInicioActualPorDefecto &&
                            this.formType !== FormType.EDITION)
                    ? environment.appName === 'avafitogest'
                        ? `${String(this.day).padStart(2, '0')}/${this.month}/${this.year}`
                        : `${String(this.day).padStart(2, '0')}/${this.month}/${this.year}`
                    : undefined,
                    isEditable: true
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: environment.appName === 'agrotata',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: (this.env.showFitoFechaReceta && !this.env.showTareasMto) || this.env.appName === 'donjardin'
                },
                order: 1
            },
        ];
        this.fieldNames = this.fieldNames.concat(tiempoFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(tiempoFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return tiempoFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getKMFields(isSectionVisible: boolean) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const kmFields: FormField<any>[] = [
            {
                name: 'punto_km_inicio',
                vinculatedFields: undefined,
                label: 'Punto Km inicial',
                input: {type: InputType.TEXT, isEditable: true},
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 1
            },
            {
                name: 'punto_km',
                vinculatedFields: undefined,
                label: 'Punto Km final',
                input: {type: InputType.TEXT, isEditable: true},
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 2
            }
        ];
        this.fieldNames = this.fieldNames.concat(kmFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(kmFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return kmFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getLugarFields() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const lugarFields: FormField<any>[] = [
            {
                name: this.formType < 3 ? 'id_finca' : 'finca',
                vinculatedFields: undefined,
                label: this.env.fincaName,
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.lists.fincas,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: createClientScopedLegacyFilter<TareaFitoModel>({
                            isEnabled: () => this.env.hasClients && this.formType !== FormType.EDITION && this.env.userCanSeeClientes,
                        }),
                    }
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: true,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: (this.env.hasFincas && this.env.showTareasFincas) || this.env.appName === 'detorres'
                },
                order: 2
            },
            {
                name: this.formType < 3 ? 'id_sector' : 'sectores_nombres',
                dependencies: [
                    {
                        source: 'id_finca',
                        target: this.formType < 3 ? 'id_sector' : 'sectores_nombres',
                        kind: 'filter'
                    }
                ],
                vinculatedFields: undefined,
                label: this.env.sectorName,
                input: {
                    type: this.env.showTareasFitoSectorMultiple ? InputType.MULTISELECT_SEARCH : InputType.DROPDOWN,
                    data: this.lists.sectores,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (option: FilteredValue<SectorModel>, context?: DropdownFilterContext<SectorModel>): boolean | undefined => {
                            if (this.env.appName === 'detorres' && this.usuario.rol === 'aplicador') {
                                return true;
                            }

                            return createFincaScopedLegacyFilter<SectorModel>()(option, context);
                        }
                    }
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasSector
                },
                order: 3
            },
            {
                name: this.formType < 3 ? 'ids_parcelas' : 'parcelas_nombres',
                dependencies: [
                    {
                        source: 'id_finca',
                        target: this.formType < 3 ? 'ids_parcelas' : 'parcelas_nombres',
                        kind: 'filter'
                    },
                    {
                        source: 'id_sector',
                        target: this.formType < 3 ? 'ids_parcelas' : 'parcelas_nombres',
                        kind: 'filter'
                    }
                ],
                vinculatedFields: undefined,
                label: this.env.parcelasName,
                input: {
                    type: InputType.MULTISELECT_SEARCH,
                    data: this.lists.parcelas,
                    isEditable: true,
                    dropdownConfiguration: {
                        summation: {
                            summand: 'superficie_cultivada',
                            name: this.env.tipoSuperficieParcelas,
                            uds: this.env.textoSuperficie,
                            format: (total: number) =>
                                total.toLocaleString('es-ES', {
                                    useGrouping: true,
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                        },
                        valuePrimaryKey: 'id',
                        filter: createParcelasScopedLegacyFilter<TareaFitoModel>({
                            sectorFieldName: 'id_sector',
                            isSectorFilterEnabled: () => this.env.showTareasSector,
                        }),
                    }
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: this.env.appName !== 'donjardin',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasParcela
                },
                order: 4
            },
            {
                name: 'sup_cultivada',
                vinculatedFields: undefined,
                label: 'Sup Tratada (Franja Protección)',
                input: {type: InputType.TEXT, isEditable: true},
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'avafitogest'
                },
                order: 5
            }
        ];
        this.fieldNames = this.fieldNames.concat(lugarFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(lugarFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return lugarFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getTratamientoFields() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tratamientoFields: FormField<any>[] = [
            {
                name: this.formType < 3 ? 'ids_trabajadores' : 'trabajadores_nombres',
                vinculatedFields: undefined,
                label: this.env.aplicadoresName,
                input: {
                    type: InputType.MULTISELECT_SEARCH,
                    data: this.lists.trabajadores,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it: FilteredValue<MantenimientoModel>) => {
                            if (it.value?.activo?.toString() !== '1') {
                                return false;
                            }

                            this.showExpirationIdentifier(it);

                            if ((this.env.appName === 'avafitogest' || this.env.appName === 'benibal') && it.value?.tipo_carnet === 'ASESOR') {
                                return false;
                            }

                            return true;
                        },
                    }
                },
                width: this.env.appName === 'avafitogest' ? 4 : 6,
                computed: {
                    dependsOn: ['id_maquinaria'],
                    resolve: (context) => this.resolveTrabajadorFromMaquinaria(
                        context.getValue('id_maquinaria'),
                        context.currentValue,
                    ),
                },
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 1
            },
            {
                name: this.formType < 3 ? 'ids_asignados' : 'nombres_asignados',
                vinculatedFields: undefined,
                label: 'Asignador',
                input: {
                    type: InputType.MULTISELECT,
                    data: this.lists.usuarios,
                    isEditable: true,
                    dropdownConfiguration: {valuePrimaryKey: 'id'}
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: true,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: (this.env.showAssignUserTasksFitosanitario || this.env.showAssignUserInAllTasks) &&
                        this.usuario.rol === 'admin'
                },
                order: 2
            },
            {
                name: 'momento_aplicacion',
                vinculatedFields: undefined,
                label: 'Momento de aplicación',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.momentosAplicacion,
                    isEditable: true
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showFitoMomentoAplicacion
                },
                order: 3
            },
            {
                name: 'coste_tratamiento',
                vinculatedFields: undefined,
                label: 'Coste (€)',
                input: {type: InputType.NUMERIC, isEditable: true},
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showFitoCosteTratamiento
                },
                order: 4
            },
            {
                name: 'tipo_tratamiento',
                vinculatedFields: undefined,
                label: 'Tipo de tratamiento',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.tiposTratamiento,
                    isEditable: true
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showFitoTipoTratamiento
                },
                order: 5
            },
            {
                name: this.formType < 3 ? 'id_tratamiento' : 'tratamiento_nombre',
                dependencies: [
                    {
                        source: 'id_cliente',
                        target: this.formType < 3 ? 'id_tratamiento' : 'tratamiento_nombre',
                        kind: 'filter'
                    },
                    {
                        source: 'id_finca',
                        target: this.formType < 3 ? 'id_tratamiento' : 'tratamiento_nombre',
                        kind: 'filter'
                    }
                ],
                vinculatedFields: undefined,
                label: 'Tratamientos',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.lists.tratamientos,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (option: FilteredValue<TratamientosModel>, context?: DropdownFilterContext<TratamientosModel>) => {
                            if (!this.isValidTratamientoOption(option)) {
                                return false;
                            }

                            const allTratamientosAllowed =
                                this.env.mostrarTodosTratamientos ||
                                ['abonosfolques', 'agricar', 'lluchychulbi'].includes(this.env.appName) ||
                                !this.env.hasClients ||
                                this.formType === FormType.DUPLICATION ||
                                !this.env.userCanSeeClientes;

                            if (allTratamientosAllowed) {
                                return true;
                            }

                            return createClientScopedCatalogueLegacyFilter<TratamientosModel>({
                                requireActive: false,
                                getClientId: (filterContext) => this.resolveCatalogueClientId(filterContext),
                            })(option, context);
                        },
                    }
                },
                buttons: [{
                    label: '',
                    class: 'btn btn-outline-secondary border-0  ml-4 rounded-5 text-sm',
                    style: `
                        margin-top: -10px;
                    `,
                    icon: 'fa fa-info text-primary',
                    tooltip: 'Ver información de los productos',
                    tooltipPosition: 'top',
                    function: () => this.getInfoProductos()
                }],
                width: this.env.appName === 'avafitogest' ? 4 : 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 6
            },
            {
                name: 'ph_caldo',
                vinculatedFields: undefined,
                label: 'pH caldo',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.ph_caldo,
                    isEditable: true
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showPhCaldo
                },
                order: 8
            },
            {
                name: 'litros',
                vinculatedFields: undefined,
                label: this.env.appName === 'momparler' ? 'Litros/m²' : this.env.appName === 'agrosalvi' ? 'Volumen (gr o litros agua)' :
                    this.env.appName === 'onda' ? 'Litros' : this.env.appName === 'hernandorena' ? 'Caldo (litros)' :
                        this.env.appName !== 'innovia' ?
                            'Volumen de Caldo (Litros/' + this.env.textoSuperficie + ')' + ((this.env.appName === 'vginer' ||
                                this.env.appName === 'tomega') ? ' (recomendación)' : '') :
                            'Litros Caldo',
                input: {type: InputType.NUMERIC, isEditable: true},
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 9
            },
            {
                name: 'mochila',
                vinculatedFields: undefined,
                label: 'Es mochila',
                input: {type: InputType.SWITCH, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoMochila
                },
                order: 10
            },
            {
                name: 'sup_tratada',
                vinculatedFields: undefined,
                label: 'Superficie tratada',
                input: {
                    type: InputType.DROPDOWN,
                    data: list(['...', null], 'T', 'P', 'F'),
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf'
                },
                order: 11
            },
            {
                name: 'orden_asesor',
                vinculatedFields: undefined,
                dependencies: [
                    {
                        source: 'fecha_inicio',
                        target: 'orden_asesor',
                        kind: 'visibility'
                    },
                    {
                        source: 'orden_asesor',
                        target: 'referencia_receta',
                        kind: 'computed'
                    },
                    {
                        source: 'fecha_inicio',
                        target: 'referencia_receta',
                        kind: 'computed'
                    }
                ],
                label: 'Orden asesor',
                input: {type: InputType.SWITCH, isEditable: true},
                width: 6,
                turnVisible: (it: FormField<object>, context?: ReactiveFieldLogicContext<object>) => {
                    this.updateOrdenAsesorReference(it, context);
                },
                conditions: {
                    isRememberedOnDuplicate: false,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf'
                },
                order: 12
            },
            {
                name: 'aplicacion',
                vinculatedFields: undefined,
                label: 'Modo de aplicación',
                input: {
                    type: InputType.DROPDOWN,
                    data: list(['...', null], 'Arcén', 'Medianera'),
                    isEditable: true
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoAplicacion
                },
                order: 13
            },
            {
                name: 'procura',
                vinculatedFields: undefined,
                label: 'Procura',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: list(['...', null], 'Procura', 'Media procura', 'Libre'),
                    isEditable: true
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasProcura
                },
                order: 14
            },
            {
                name: 'tipo_plaga',
                vinculatedFields: undefined,
                label: 'Tipo de plaga',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.tipo_plaga,
                    isEditable: true
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTipoPlaga
                },
                order: 15
            },
            {
                name: 'litros_totales',
                vinculatedFields: undefined,
                label: 'Litros Totales',
                input: { type: InputType.TEXT, isEditable: true },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'gragon'
                },
                order: 16
            },
            {
                name: 'motivo',
                vinculatedFields: undefined,
                label: 'Motivo',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.motivo,
                    isEditable: true
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showMotivoFito && this.env.appName !== 'gragon'
                },
                order: 17,
            },
            {
                name: this.formType < 3 ? 'codigo_justificacion' : 'justificacion_actuacion',
                vinculatedFields: undefined,
                label: 'Justificación de la Actuación',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.lists.justificaciones,
                    isEditable: true,
                    dropdownConfiguration: {valuePrimaryKey: 'codigo'}
                },
                width: this.env.appName === 'donjardin' ? 4 : 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 18
            },
            {
                name: 'desplazamiento',
                vinculatedFields: undefined,
                label: 'Desplazamiento',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.desplazamiento,
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showDesplazamientoObra
                },
                order: 19
            },
            {
                name: 'mano_obra',
                vinculatedFields: undefined,
                label: 'Mano Obra',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.mano_obra,
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showDesplazamientoObra
                },
                order: 20
            },
            {
                name: 'observaciones',
                vinculatedFields: undefined,
                label: this.env.appName === 'momparler' ? 'Recomendación/Especie' : this.env.appName === 'avafitogest' ? 'Observaciones' : 'Recomendación',
                input: {
                    type: InputType.TEXTAREA,
                    isEditable: true,
                    textAreaConfiguration: {
                        hasVoiceTranscription: true,
                        canTakePhoto: false,
                        photoField: undefined
                    }
                },
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoObservaciones
                },
                order: 21
            },
            {
                name: 'momento_aplicacion',
                vinculatedFields: undefined,
                label: 'Momento de aplicación',
                input: { type: InputType.TEXT, isEditable: true },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showMomentoAplicacion
                },
                order: 22
            },
            {
                name: 'limpieza_epis',
                vinculatedFields: undefined,
                label: 'Limpieza de EPIs',
                input: {type: InputType.SWITCH, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'vginer'
                },
                order: 23
            },
            {
                name: 'dia_limpieza',
                vinculatedFields: undefined,
                label: 'Día de limpieza',
                input: {type: InputType.CALENDAR, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'vginer'
                },
                order: 24
            },
            {
                name: 'it',
                vinculatedFields: undefined,
                label: 'Instrucción técnica',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoIT
                },
                order: 25
            },
            {
                name: 'lote',
                vinculatedFields: undefined,
                label: this.env.appName === 'momparler' ? 'N° Pedido' : 'Lote',
                input: {type: InputType.TEXT, isEditable: true},
                width: 6,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoLote
                },
                order: 26
            },
            {
                name: 'tecnica',
                vinculatedFields: undefined,
                label: 'Técnica',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.tecnica,
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf'
                },
                order: 27
            },
            {
                name: 'notas_cliente',
                vinculatedFields: undefined,
                label: 'Notas cliente',
                input: {
                    type: InputType.TEXTAREA,
                    defaultValue: this.formType === FormType.CREATION ? StorageManager.getClient()?.notas : null,
                    isEditable: false,
                },
                width: this.env.appName === 'donjardin' ? 6 : 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: true,
                    hasUndoEnabled: false,
                    isVisible: this.env.showClientesNotas
                },
                order: 28
            },
            {
                name: 'estado_tarea',
                vinculatedFields: undefined,
                label: 'Estado de la Tarea',
                input: {
                    type: InputType.DROPDOWN,
                    data: this.lists.estadoTarea,
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'onda' || this.env.appName === 'lacooperativa'
                },
                order: 29
            },
            {
                name: 'empresa_pagadora',
                vinculatedFields: undefined,
                label: 'Empresa Pagadora',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'onda' || this.env.appName === 'lacooperativa'
                },
                order: 30
            },
        ];

        /* Due to the item being also part of another section, should be pushed instead of being puted directly in the array.
          Despite being set as not visible, the form builder still is able to loop around it and overrides the value of the
          latter apparition of the field. */
        if (this.env.showTareasFitoMaquinarias &&
            !(this.env.showTractorBoquillas || this.env.showTractorPresion, this.env.showTractorMarcha || this.env.showTractorRPM)
        ) {
            tratamientoFields.push(            {
                name: this.formType < 3 ? 'id_maquinaria' : 'maquinaria',
                dependencies: [
                    {
                        source: 'id_cliente',
                        target: this.formType < 3 ? 'id_maquinaria' : 'maquinaria',
                        kind: 'filter'
                    },
                    {
                        source: 'ids_trabajadores',
                        target: this.formType < 3 ? 'id_maquinaria' : 'maquinaria',
                        kind: 'computed'
                    }
                ],
                vinculatedFields: this.env.appName === 'pyf' ? ['ids_cliente', 'ids_trabajadores', 'id_maquinaria'] : undefined,
                label: 'Maquinaria',
                input: {
                    type:
                        (this.env.appName === 'bravosol' || this.env.appName === 'agrosalvi' || this.env.appName === 'avafitogest') ?
                            InputType.MULTISELECT_SEARCH : InputType.DROPDOWN_SEARCH,
                    data: this.lists.maquinarias,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (option: FilteredValue<MaquinariaModel>, context?: DropdownFilterContext<MaquinariaModel>) =>
                            this.filterMaquinariaOption(option, context),
                    }
                },
                width: this.env.appName === 'avafitogest' ? 4 : 6,
                computed: {
                    dependsOn: ['ids_trabajadores'],
                    resolve: (context) => this.resolveMaquinariaFromWorkers(
                        context.getValue('ids_trabajadores'),
                        context.currentValue,
                        this.env.appName === 'bravosol' || this.env.appName === 'agrosalvi' || this.env.appName === 'avafitogest',
                    ),
                },
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible:
                    this.env.showTareasFitoMaquinarias &&
                    !(this.env.showTractorBoquillas || this.env.showTractorPresion, this.env.showTractorMarcha || this.env.showTractorRPM)
                },
                order: 1
            });
        }
        this.fieldNames = this.fieldNames.concat(tratamientoFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(tratamientoFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return tratamientoFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getTractorFields(isSectionVisible: boolean) {
        const tractorFields: FormField<any>[] = [
            {
                name: 'velocidad',
                vinculatedFields: undefined,
                label: 'Velocidad\xa0(Km/h)',
                input: {type: InputType.NUMERIC, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showTractorVelocidad
                },
                order: 2
            },
            {
                name: 'marcha',
                vinculatedFields: undefined,
                label: 'Marcha',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showTractorMarcha
                },
                order: 3
            },
            {
                name: 'rpm',
                vinculatedFields: undefined,
                label: 'RPM',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.lists.rpmValues,
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showTractorRPM
                },
                order: 4
            },
            {
                name: 'presion',
                vinculatedFields: undefined,
                dependencies: [
                    {
                        source: 'id_maquinaria',
                        target: 'presion',
                        kind: 'legacy'
                    }
                ],
                label: 'Presión\xa0(atm-bar)',
                input: {
                    type: (['simat', 'laplana'].includes(this.env.appName)) ? InputType.DROPDOWN : InputType.NUMERIC,
                    data: ['simat', 'laplana'].includes(this.env.appName) ? this.getDefaultPresionValues() : {},
                    isEditable: true,
                    dropdownConfiguration: {
                        swap: (it: FormField<object>, context?: ReactiveFieldLogicContext<object>) => {
                            if (this.env.appName === 'simat') {
                                it.input.data = this.getPresionValuesForMaquinaria(
                                    context?.getValue('id_maquinaria') ?? this.model.id_maquinaria,
                                );
                            }
                        },
                    }
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showTractorPresion
                },
                order: 5
            },
            {
                name: 'boquillas',
                vinculatedFields: undefined,
                label: 'Boquillas',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showTractorBoquillas
                },
                order: 6
            },
            {
                name: 'km_recorridos',
                vinculatedFields: undefined,
                label: 'Km recorridos',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showTractorKmRecorridos
                },
                order: 7
            }
        ];

        if (this.env.showTareasFitoMaquinarias &&
            (this.env.showTractorBoquillas || this.env.showTractorPresion, this.env.showTractorMarcha || this.env.showTractorRPM)
        ) {
            tractorFields.push(
                    {
                name: this.formType < 3 ? 'id_maquinaria' : 'maquinaria',
                dependencies: [
                    {
                        source: 'id_cliente',
                        target: this.formType < 3 ? 'id_maquinaria' : 'maquinaria',
                        kind: 'filter'
                    },
                    {
                        source: 'ids_trabajadores',
                        target: this.formType < 3 ? 'id_maquinaria' : 'maquinaria',
                        kind: 'computed'
                    }
                ],
                vinculatedFields: this.env.appName === 'pyf' ? ['ids_cliente', 'id_maquinaria'] : undefined,
                label: 'Maquinaria',
                input: {
                    type:
                        (this.env.appName === 'bravosol' || this.env.appName === 'agrosalvi') ?
                            InputType.MULTISELECT : InputType.DROPDOWN_SEARCH,
                    data: this.lists.maquinarias,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (option: FilteredValue<MaquinariaModel>, context?: DropdownFilterContext<MaquinariaModel>) =>
                            this.filterMaquinariaOption(option, context),
                    }
                },
                width: 4,
                computed: {
                    dependsOn: ['ids_trabajadores'],
                    resolve: (context) => this.resolveMaquinariaFromWorkers(
                        context.getValue('ids_trabajadores'),
                        context.currentValue,
                        false,
                    ),
                },
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showTareasFitoMaquinarias
                },
                order: 1
            });
        }
        this.fieldNames = this.fieldNames.concat(tractorFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(tractorFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return tractorFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getInnoviaFields(isSectionVisible: boolean) {
        const innoviaFields: FormField<any>[] = [
            {
                name: 'litros1',
                vinculatedFields: undefined,
                dependencies: this.createLitrosLabelDependencies('litros1'),
                label: this.formType === FormType.EXPORT ? 'Litros 1': 'Litros ',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 4,
                turnVisible: (it: FormField<object>, context?: ReactiveFieldLogicContext<object>) =>
                    this.changeLitrosLabel(0, it, context),
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 1
            },
            {
                name: 'litros2',
                vinculatedFields: undefined,
                dependencies: this.createLitrosLabelDependencies('litros2'),
                label: this.formType === FormType.EXPORT ? 'Litros 2': 'Litros ',
                input: {type: InputType.NUMERIC, isEditable: true},
                width: 4,
                turnVisible: (it: FormField<object>, context?: ReactiveFieldLogicContext<object>) =>
                    this.changeLitrosLabel(1, it, context),
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 2
            },
            {
                name: 'litros3',
                vinculatedFields: undefined,
                dependencies: this.createLitrosLabelDependencies('litros3'),
                label: this.formType === FormType.EXPORT ? 'Litros 3': 'Litros ',
                input: {type: InputType.NUMERIC, isEditable: true},
                width: 4,
                turnVisible: (it: FormField<object>, context?: ReactiveFieldLogicContext<object>) =>
                    this.changeLitrosLabel(2, it, context),
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 3
            },
        ];
        this.fieldNames = this.fieldNames.concat(innoviaFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(innoviaFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return innoviaFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getFinalFields() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const finalFields: FormField<any>[] = [
            {
                name: 'hora_inicio',
                vinculatedFields: undefined,
                label: 'Hora Inicio',
                input: {type: InputType.TIME, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: !this.env.showTareasMto,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasMto || this.env.showTareasFitoHoras || this.env.timeStartStopTareas
                },
                order: 1
            },
            {
                name: 'hora_fin',
                vinculatedFields: undefined,
                label: 'Hora Fin',
                input: {
                    type: InputType.TIME,
                    defaultValue:
                    (this.env.horaFechaFinActualPorDefecto || this.env.showTareasMto && this.usuario.rol === 'user') ?
                        this.formType !== FormType.EDITION ? `${this.hours}:${this.minutes}` :
                            undefined : undefined,
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: !this.env.showTareasMto,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible:
                        this.env.showTareasMto ||
                        this.env.showTareasFitoHoras ||
                        this.env.timeStartStopTareas
                },
                order: 2
            },
            {
                name: 'horas_totales',
                vinculatedFields: undefined,
                label: 'Horas',
                input: {
                    type: this.env.appName === 'fotoagricultura' ? InputType.NUMERIC : InputType.ONLY_TEXT,
                    isEditable: true
                },
                width: 4,
                ...(this.env.appName !== 'fotoagricultura' && {
                    computed: {
                        dependsOn: ['hora_inicio', 'hora_fin'],
                        resolve: (context) => this.formatoHorasMinutos(
                            String(context.getValue('hora_inicio') ?? this.horaInicio ?? '00:00'),
                            String(context.getValue('hora_fin') ?? this.horaFin ?? '00:00'),
                        ),
                    },
                }),
                conditions: {
                    isRememberedOnDuplicate: !this.env.showTareasMto,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasMto || this.env.tareasHorasTotales || this.env.showTareasFitoHoras || this.env.appName === 'fotoagricultura',
                },
                order: 3
            },
            {
                name: 'fecha_fin',
                vinculatedFields: undefined,
                label: (this.env.appName === 'armentia') ? 'Fecha fin' : 'Fecha Aplicación',
                input: {
                    type: InputType.CALENDAR,
                    defaultValue: ((this.env.horaFechaFinActualPorDefecto &&
                                this.formType !== FormType.EDITION &&
                                this.env.appName !== 'sirga' &&
                                this.env.appName !== 'yagoaznar') || this.env.appName === 'tomega' &&
                            this.formType === FormType.EDITION)
                        ? `${this.day}/${this.month}/${this.year}` : undefined,
                    isEditable: true,
                    calendarConfiguration: {
                        calendarView: 'date',
                        calendarDateFormat: 'dd/mm/yy',
                        disabledDates: [],
                        onSelect: (date: Date) => {
                            if (this.env.appName !== 'detorres') {
                                return;
                            }

                            const matches = this.eventos.filter(e => {
                                const parts = e.start.split('-');
                                if (parts.length !== 3) {
                                    return false;
                                }
                                const d = Number(parts[0]);
                                const m = Number(parts[1]);
                                const y = Number(parts[2]);

                                return date.getFullYear() === y &&
                                    date.getMonth()    === m - 1 &&
                                    date.getDate()     === d;
                            });

                            if (matches.length === 0) {
                                return;
                            }

                            const mensaje = matches
                                .map((ev, i) =>
                                    `Evento ${i + 1}:\n` +
                                `• Título: ${ev.title}\n` +
                                `• Hora inicio: ${ev.hora_inicio}\n` +
                                `• Hora fin: ${ev.hora_fin}`
                                )
                                .join('\n\n');

                            alert(mensaje);
                        }
                    }
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: false,
                    isRequired: (this.env.appName === 'agrosalvi' && this.usuario.rol === 'user') || environment.appName === 'agrotata',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 4
            },
            {
                name: 'fin_fecha',
                vinculatedFields: undefined,
                label: 'Fecha fin',
                input: {type: InputType.CALENDAR, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'fotoagricultura',
                },
                order: 5
            },
            {
                name: 'fecha_recoleccion',
                vinculatedFields: undefined,
                label: 'Fecha Recolección',
                input: {type: InputType.CALENDAR, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'vginer'
                },
                order: 6
            },
            {
                name: this.formType < 3 ? 'eficacia' : 'eficacia_nombre',
                vinculatedFields: undefined,
                label: 'Eficacia del Tratamiento',
                input: {
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.lists.eficacia,
                    defaultValue: '1',
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: false,
                    isRequired: this.env.appName === 'agrosalvi' && this.usuario.rol === 'user',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true,
                },
                order: 7
            },
            {
                name: 'aplicado',
                vinculatedFields: undefined,
                label: this.env.appName === 'donjardin' ? 'Aplicado' : 'Revisado',
                input: {
                    type: InputType.SWITCH,
                    defaultValue: (this.env.showTareasMto && this.usuario.rol === 'user') ? '1' : '0',
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: false,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: (this.usuario.rol !== 'user') || this.env.showAplicadoSwitch
                },
                order: 8
            },
            {
                name: 'validado',
                vinculatedFields: undefined,
                label: 'Validado',
                input: {type: InputType.SWITCH, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showFitoValidado && (this.usuario.rol === 'admin')
                },
                order: 9
            },
            {
                name: 'soleado',
                vinculatedFields: undefined,
                label: 'Soleado',
                input: {
                    type: InputType.DROPDOWN,
                    data: list(['...', null], 'Cubierto', 'Semicubierto', 'Despejado'),
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoSoleado
                },
                order: 10
            },
            {
                name: 'cubas_totales',
                vinculatedFields: undefined,
                label: 'Cubas totales',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'vginer'
                },
                order: 11
            },
            {
                name: 'litros_aplicados',
                vinculatedFields: undefined,
                label: this.env.appName === 'ava' ? 'Vol. Caldo Gastado' : 'Litros aplicados',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoLitrosAplicados
                },
                order: 12
            },
            {
                name: 'litros_aplicados_ha',
                vinculatedFields: undefined,
                label: 'Litros aplicados/Ha',
                input: {type: InputType.ONLY_TEXT, isEditable: true},
                width: 4,
                computed: {
                    dependsOn: ['sup_cultivada', 'litros_aplicados'],
                    resolve: (context) => this.calculateLitrosAplicadosHa(
                        context.getValue('sup_cultivada'),
                        context.getValue('litros_aplicados'),
                    ),
                },
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasFitoLitrosAplicados && !this.env.showCostes
                },
                order: 13
            },
            {
                name: 'facturado',
                vinculatedFields: undefined,
                label: 'Facturado',
                input: {type: InputType.SWITCH, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agrosalvi'
                },
                order: 14
            },
            {
                name: 'factura_albaran',
                vinculatedFields: undefined,
                label: 'Factura/Albarán',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agrosalvi'
                },
                order: 15
            }
        ];
        this.fieldNames = this.fieldNames.concat(finalFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(finalFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return finalFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getClimaFields(isSectionVisible: boolean) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const climaFields: FormField<any>[] = [
            {
                name: 'temperatura',
                vinculatedFields: undefined,
                label: 'Temperatura ℃',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 1
            },
            {
                name: 'hr',
                vinculatedFields: undefined,
                label: this.env.appName === 'torrepacheco' ? 'Humedad %' : 'Humedad R.',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 2
            },
            {
                name: 'viento',
                vinculatedFields: undefined,
                label: 'Viento Km/h',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 3
            },
            {
                name: 'precip',
                vinculatedFields: undefined,
                label: 'Precipit. L/m²',
                input: {type: InputType.TEXT, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 4
            },
            {
                name: 'clima',
                vinculatedFields: undefined,
                label: 'Clima',
                input: {
                    type: InputType.DROPDOWN,
                    data: list(['...', null], 'Cubierto', 'Semidespejado', 'Despejado'),
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && (this.env.appName === 'vginer')
                },
                order: 5
            },
            {
                name: 'climatologia',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.SELECT_BUTTON,
                    data: list( ['Obtener clima', null] ),
                    isEditable: true,
                    selectButtonConfiguration: {
                        isDisabled: false,
                        isMultiSelect: false,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onClick: (it: FormField<any>) => this.checkWeatherVariables(it)
                    }
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: true,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 6
            },
        ];
        this.fieldNames = this.fieldNames.concat(climaFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(climaFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return climaFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getMezclasSobrantesFields(isSectionVisible: boolean) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mezcalsSobrantesFields: FormField<any>[] = [
            {
                name: 'cubeto_evaporacion',
                vinculatedFields: undefined,
                label: 'Cubeto evaporación',
                input: {type: InputType.SWITCH, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 1
            },
            {
                name: 'punto_carga',
                vinculatedFields: undefined,
                label: 'Punto carga',
                input: {type: InputType.SWITCH, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 2
            },
            {
                name: 'litros_sobrante',
                vinculatedFields: undefined,
                label: 'Litros caldo sobrante',
                input: {type: InputType.NUMERIC, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible,
                },
                order: 3
            },
            {
                name: 'dia_tratamiento',
                vinculatedFields: undefined,
                label: 'Día tratamiento',
                input: {type: InputType.CALENDAR, isEditable: true},
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 4
            },
        ];
        this.fieldNames = this.fieldNames.concat(mezcalsSobrantesFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(mezcalsSobrantesFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return mezcalsSobrantesFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getOrdenTrabajoFields(isSectionVisible: boolean) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const ordenTrabajoFields: FormField<any>[] = [
            {
                name: 'orden_trabajo',
                vinculatedFields: undefined,
                label: 'Orden de trabajo',
                input: {
                    type: InputType.TEXTAREA,
                    isEditable: this.usuario.rol === 'admin',
                    textAreaConfiguration: {
                        hasVoiceTranscription: true,
                        canTakePhoto: true,
                        photoField: 'imagen'
                    },
                },
                width: 12,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible,
                },
                order: 1
            },
        ];
        this.fieldNames = this.fieldNames.concat(ordenTrabajoFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(ordenTrabajoFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return ordenTrabajoFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getObsFields(isSectionVisible: boolean) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const obsFields: FormField<any>[] = [
            {
                name: 'observaciones',
                vinculatedFields: undefined,
                label: 'Observaciones',
                input: {
                    type: InputType.TEXTAREA,
                    isEditable: true,
                    textAreaConfiguration: {
                        hasVoiceTranscription: true,
                        canTakePhoto: true,
                        photoField: 'image_after'
                    }
                },
                width: 12,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible,
                },
                order: 1
            }
        ];
        this.fieldNames = this.fieldNames.concat(obsFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(obsFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return obsFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private formatoHorasMinutos(horaEntrada: string, horaSalida: string): string {

        if (!this.isValidTime(horaEntrada) || !this.isValidTime(horaSalida)) {
            console.error('El formato de hora no es válido. Asegúrese de que el formato sea HH:mm');
            return '00:00';
        }

        const duracion = moment.duration(
            moment(horaSalida, 'HH:mm').diff(moment(horaEntrada, 'HH:mm'))
        );

        return `${this.padZero(2, Math.floor(duracion.asHours()).toString())}:${this.padZero(2, duracion.minutes().toString())}`;
    }

    private isValidTime(hora: string): boolean {
        return moment(hora, 'HH:mm', true).isValid();
    }

    private showExpirationIdentifier(it: FilteredValue<MaquinariaModel | MantenimientoModel | TratamientosModel>) {
        if (it.label.includes('*')) {
            return;
        }

        // Si no está activo, marcar como ** (doble asterisco)
        if (!it.value?.activo) {
            it.label = `** ${it.label}`;
            return;
        }

        // Verificar fecha de caducidad general (fecha_caducidad o fecha_ultima_inspeccion)
        const fechaCaducidad = this.obtenerFechaCaducidad(it.value as MaquinariaModel);
        if (!fechaCaducidad) {
            return;
        }

        const hoy = moment();
        const tresMeses = moment().add(3, 'months');
        const tiempoAntes = this.comprobarTiempoAntes(fechaCaducidad);

        // Evaluar estado de la fecha de caducidad
        if (fechaCaducidad.isBefore(hoy)) {
            it.label = `** ${it.label}`; // Expirado
        } else if (fechaCaducidad.isBefore(tresMeses) || tiempoAntes) {
            it.label = `* ${it.label}`; // Próximo a caducar
        }
    }

    private obtenerFechaCaducidad(value: MaquinariaModel): moment.Moment | null {
        if (value?.fecha_caducidad) {
            return moment(Utils.toDate(value.fecha_caducidad));
        }

        if (value?.fecha_ultima_inspeccion) {
            const auxFechaCad = (value.fecha_ultima_inspeccion as string).split('/');
            const edadMaquinaria = moment().year() - moment(value.fecha_adquisicion, 'DD/MM/YYYY').year();

            const incremento = edadMaquinaria > 10 || isNaN(edadMaquinaria)
                ? parseInt(auxFechaCad[2] ?? '', 10) >= 2020 ? 3 : 5
                : 10;

            auxFechaCad[2] = (parseInt(auxFechaCad[2] ?? '', 10) + incremento).toString();

            return moment(`${auxFechaCad[0]}/${auxFechaCad[1]}/${auxFechaCad[2]}`, 'DD/MM/YYYY');
        }

        return null;
    }

    private comprobarTiempoAntes(fechaCaducidad: moment.Moment): boolean {
        const margen = this.env.appName === 'prodalbar' ? '1 years' : '3 months';
        return fechaCaducidad.isBefore(moment().add(moment.duration(margen)));
    }


    private parseFecha(fechaInicio: string | Date): Date {
        if (fechaInicio.toString().length === 10) {
            const [dia, mes, anio] = fechaInicio.toString().split('/').map(Number);
            return new Date(anio ?? 0, (mes ?? 0) - 1, dia);
        }
        return new Date(fechaInicio);
    }

    private padZero(maxLength: number, numero: string): string {
        return numero.padStart(maxLength, '0');
    }



    private updateOrdenAsesorReference(
        field: FormField<object>,
        context?: ReactiveFieldLogicContext<object>,
    ): void {
        const isOrdenAsesorEnabled = this.toBoolean(context?.getValue('orden_asesor') ?? this.model.orden_asesor);
        const fechaValue = context?.getValue('fecha_inicio') ?? this.model.fecha_inicio;

        if (!isOrdenAsesorEnabled || !fechaValue) {
            this.setOrdenAsesorReference(field, '', context);
            field.label = 'Orden asesor';
            field.input.isEditable = true;
            return;
        }

        const existingReference = this.resolveReferenciaRecetaValue(context?.getValue('referencia_receta'));

        if (existingReference.length > 0) {
            this.setOrdenAsesorReference(field, existingReference, context);
            return;
        }

        const fecha = this.parseFecha(fechaValue as string | Date);
        const year = fecha.getFullYear();

        if (!Number.isFinite(year) || this.pendingReferenciaRecetaYear === year) {
            return;
        }

        this.pendingReferenciaRecetaYear = year;
        void firstValueFrom(this.recuperarService.getRecuperarReferencia(year))
            .then((resp) => {
                const numero = this.padZero(3, String(resp?.data[0]?.numero ?? ''));
                const referenciaReceta = `${year}-${numero}`;

                this.setOrdenAsesorReference(field, referenciaReceta, context);
            })
            .catch((error: unknown) => console.error('Error en getRecuperarReferencia:', error))
            .finally(() => {
                this.pendingReferenciaRecetaYear = null;
            });
    }

    private setOrdenAsesorReference(
        field: FormField<object>,
        referenciaReceta: string,
        context?: ReactiveFieldLogicContext<object>,
    ): void {
        this.referenciaReceta = referenciaReceta.length > 0 ? referenciaReceta : null;
        this.model.referencia_receta = referenciaReceta;
        field.label = referenciaReceta.length > 0 ? `Orden asesor - ${referenciaReceta}` : 'Orden asesor';
        field.input.isEditable = referenciaReceta.length === 0;

        const control = context?.model.get('referencia_receta');

        if (control && control.value !== referenciaReceta) {
            context?.model.patchValue({ referencia_receta: referenciaReceta }, { emitEvent: false });
            control.markAsPristine();
            control.markAsUntouched();
        }
    }

    private resolveReferenciaRecetaValue(currentValue: unknown): string {
        const current = this.toTextValue(this.referenciaReceta ?? currentValue ?? this.model.referencia_receta);

        if (current.length > 0) {
            this.referenciaReceta = current;
        }

        return current;
    }

    private toBoolean(value: unknown): boolean {
        if (typeof value === 'boolean') {
            return value;
        }

        if (typeof value === 'number') {
            return value !== 0;
        }

        const normalized = String(value ?? '').trim().toLowerCase();

        return normalized === '1' || normalized === 'true' || normalized === 'si' || normalized === 'sí';
    }

    private toTextValue(value: unknown): string {
        if (value === null || value === undefined) {
            return '';
        }

        return String(value).trim();
    }

    private createLitrosLabelDependencies(target: string) {
        return [
            {
                source: 'ids_productos',
                target,
                kind: 'visibility' as const
            },
            {
                source: 'productos_nombres',
                target,
                kind: 'visibility' as const
            }
        ];
    }

    private changeLitrosLabel(
        productIndex: number,
        it: FormField<object>,
        context?: ReactiveFieldLogicContext<object>,
    ): boolean {
        return this.changeLabel(this.resolveLitrosProductValue(productIndex, context), it);
    }

    private resolveLitrosProductValue(productIndex: number, context?: ReactiveFieldLogicContext<object>): string | undefined {
        const sourceValue = this.formType > 2
            ? context?.getValue('productos_nombres') ?? this.model.productos_nombres
            : context?.getValue('ids_productos') ?? this.model.ids_productos;
        const separator = this.formType > 2 ? ',' : ';';

        return this.splitTextValue(sourceValue, separator)[productIndex];
    }

    private splitTextValue(value: unknown, separator: string): string[] {
        if (Array.isArray(value)) {
            return value.map(String);
        }

        return String(value ?? '')
            .split(separator)
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
    }

    private changeLabel(producto: string | undefined, it: FormField<object>): boolean {
        if (!producto) {
            return true;
        }

        const productName = this.resolveProductName(producto);
        const nextLabel = 'Litros ' + (productName || 'no localizado');

        if (it.label !== nextLabel) {
            it.label = nextLabel;
        }

        return true;
    }

    private resolveProductName(producto: string): string {
        const product = this.lists.productos.values
            .map((option) => option.raw ?? option.value)
            .find((option) => this.valuesMatch(this.getObjectProperty(option, 'id'), producto) ||
                this.valuesMatch(this.getObjectProperty(option, 'nombre'), producto));

        return String(this.getObjectProperty(product, 'nombre') ?? producto);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private async checkWeatherVariables(field: FormField<any>): Promise<any> {
    const fecha = this.getFecha() ?? '';
    const finca = this.getFinca();
    const parcela = this.getParcela();
    const selectButton = field.input?.selectButtonConfiguration;

    // Validación previa: si falta info, mostrarmos alerta y GARANTIZAMOS que queda habilitado
    const alertMessage = this.getAlertMessage(fecha, finca);
    if (alertMessage) {
        alert(alertMessage);
        if (selectButton) selectButton.isDisabled = false;
        return null;
    }

    try {
        // 🔵 NO deshabilitamos aquí: solo si hay éxito más abajo

        const resp: { status: number; mensaje: string; data?: Climatologia } =
        await firstValueFrom(this.weatherService.getWeatherInfo(fecha, finca, parcela));

        if (resp.status === 400) {
        alert(resp.mensaje);
        if (selectButton) selectButton.isDisabled = false; // asegurar habilitado
        return null;
        }

        if (resp.data?.prevision) {
        const hourlyData = resp.data.prevision.hourly[0];
        // ✅ Éxito: devolvemos datos y AHORA sí deshabilitamos el botón
        if (selectButton) selectButton.isDisabled = true;
        return {
            temperatura: hourlyData?.temperature,
            precip: hourlyData?.precip,
            hr: hourlyData?.humidity,
            viento: hourlyData?.wind_speed,
        };
        }

        // Sin datos: mantener habilitado
        alert('No se han encontrado datos');
        if (selectButton) selectButton.isDisabled = false;
        return null;

    } catch (error) {
        // Error: mantener habilitado
        alert('No hay datos en esta fecha');
        console.error('Error:', error);
        if (selectButton) selectButton.isDisabled = false;
        return null;
    }
    }

    // Función auxiliar para obtener la fecha
    private getFecha(): string | null {
        let fecha = this.model.fecha_inicio || this.model.fecha_fin || null;

        if (fecha && typeof fecha === 'object') {
            fecha = moment(fecha).format('DD/MM/YYYY');
        }

        return fecha;
    }

    // Función auxiliar para obtener la finca
    private getFinca(): string {
        return this.model.id_finca
            ? (this.model.id_finca as unknown as FincasModel)?.id ?? ''
            : '';
    }

    // Función auxiliar para obtener la parcela
    private getParcela(): string {
        if (Array.isArray(this.model.ids_parcelas) && this.model.ids_parcelas.length > 0) {
            const primeraParcela = this.model.ids_parcelas[0];
            return primeraParcela?.id ?? '0'; // Assegurem que 'id' existeix
        }

        return '0';
    }

    // Función auxiliar para generar el mensaje de alerta
    private getAlertMessage(fecha: string | null, finca: string): string {
        let message = '';

        if (!fecha) {
            message += 'No hay seleccionadas ni Fecha de inicio ni Fecha de fin.\n';
        }

        if (!finca) {
            message += 'No hay finca seleccionada.';
        }

        return message;
    }

    private getFormSections() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sections: FormSection<any>[] = [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getTiempoFields(),
                order: 1
            },
            {
                name: '',
                width: 12,
                isVisible: this.env.showTareasFitoPuntoKM,
                fields: this.getKMFields(this.env.showTareasFitoPuntoKM),
                order: 2
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getLugarFields(),
                order: 3
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getTratamientoFields(),
                order: 4
            },
            {
                name: 'Condiciones meteorológicas',
                width: 6,
                isVisible: this.env.showClimatologia,
                fields: this.getClimaFields(this.env.showClimatologia),
                order: 5
            },
            {
                name: 'Mezclas sobrantes',
                width: 6,
                isVisible: this.env.appName === 'vginer',
                fields: this.getMezclasSobrantesFields(this.env.appName === 'vginer'),
                order: 6
            },
            {
                name: 'Datos de la maquinaria',
                width: 6,
                isVisible:
                    this.env.showTareasMaquinaria &&
                    (this.env.showTractorBoquillas ||
                    this.env.showTractorMarcha ||
                    this.env.showTractorPresion ||
                    this.env.showTractorRPM),
                fields: this.getTractorFields(this.env.showTareasMaquinaria &&
                    (this.env.showTractorBoquillas ||
                    this.env.showTractorMarcha ||
                    this.env.showTractorPresion ||
                    this.env.showTractorRPM)),
                order: 7
            },
            {
                name: 'Tarea finalizada',
                width: this.env.showTareasMaquinaria &&
                    (this.env.showTractorBoquillas ||
                    this.env.showTractorMarcha ||
                    this.env.showTractorPresion ||
                    this.env.showTractorRPM) ? 6 : 12,
                isVisible: true,
                fields: this.getFinalFields(),
                order: 8
            },
            {
                name: 'Productos aplicados',
                width: 12,
                isVisible: this.env.appName === 'innovia',
                fields: this.getInnoviaFields(this.env.appName === 'innovia'),
                order: 9
            },
            {
                name: '',
                width: 12,
                isVisible: this.env.appName === 'donjardin',
                fields: this.getOrdenTrabajoFields(this.env.appName === 'donjardin' || this.env.appName === 'detorres'),
                order: 10
            },
            {
                name: '',
                width: 12,
                isVisible: this.env.appName === 'donjardin',
                fields: this.getObsFields(this.env.appName === 'donjardin' || this.env.appName === 'detorres'),
                order: 11
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getHiddenFields(),
                order: 12
            }
        ];
        return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private getHiddenFields() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const hiddenFields: FormField<any>[] = [
            {
                name: 'id',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.model.id,
                    isEditable: false
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true,
                },
                order: 1
            },
            {
                name: 'id_cliente',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.resolveClientId(this.model.id_finca),
                    isEditable: false
                },
                computed: {
                    dependsOn: ['id_finca'],
                    resolve: (context) => this.resolveClientId(context.getValue('id_finca')),
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.hasClients && this.env.userCanSeeClientes
                },
                order: 2
            },
            {
                name: 'id_usuario',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.resolveUserId(this.model.id_finca),
                    isEditable: false
                },
                computed: {
                    dependsOn: ['id_finca'],
                    resolve: (context) => this.resolveUserId(context.getValue('id_finca')),
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 3
            },
            {
                name: 'cultivo',
                vinculatedFields: undefined,
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                computed: {
                    dependsOn: ['ids_parcelas'],
                    resolve: (context) => this.joinParcelasFieldFromValue(
                        context.getValue('ids_parcelas'),
                        'cultivo',
                        'cultivo',
                    ),
                },
                order: 4
            },
            {
                name: 'variedad',
                vinculatedFields: undefined,
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                computed: {
                    dependsOn: ['ids_parcelas'],
                    resolve: (context) => this.joinParcelasFieldFromValue(
                        context.getValue('ids_parcelas'),
                        'variedad',
                        'variedad',
                    ),
                },
                order: 5
            },
            {
                name: 'referencia_receta',
                vinculatedFields: undefined,
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: false,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf'
                },
                computed: {
                    dependsOn: ['orden_asesor', 'fecha_inicio'],
                    resolve: (context) => this.resolveReferenciaRecetaValue(context.currentValue),
                },
                order: 7
            },
            {
                name: 'signature_img',
                vinculatedFields: undefined,
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasMto,
                },
                order: 8
            },
            {
                name: 'id_ref_usuario',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.usuario.id,
                    isEditable: false
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: true,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'donjardin' && this.formType !== FormType.CREATION
                },
                order: 9
            },
            {
                name: 'imagen',
                vinculatedFields: undefined,
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasMto
                },
                order: 10
            },
            {
                name: 'image_after',
                vinculatedFields: undefined,
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showTareasMto
                },
                order: 11
            },
            {
                name: 'ids_productos',
                vinculatedFields: undefined,
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false, defaultValue: this.model.ids_productos},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'innovia'
                },
                order: 11
            },
        ];

        if (this.env.appName !== 'avafitogest') {
            hiddenFields.push(
                    {
                    name: 'sup_cultivada',
                    vinculatedFields: undefined,
                    label: '',
                    input: {type: InputType.HIDDEN, isEditable: false},
                    width: 2,
                    conditions: {
                        isRememberedOnDuplicate: true,
                        isRequired: false,
                        isRetained: false,
                        hasUndoEnabled: false,
                        isVisible: true
                    },
                    computed: {
                        dependsOn: ['ids_parcelas'],
                        resolve: (context) => this.joinParcelasFieldFromValue(
                            context.getValue('ids_parcelas'),
                            'superficie_cultivada',
                            'sup_cultivada',
                        ),
                    },
                    order: 6
                },
            );
        }

        return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }



    private isValidTratamientoOption(option: FilteredValue<TratamientosModel>): boolean {
        const value = option.value;
        const name = value?.nombre?.trim() ?? '';

        if (!value || name.length === 0 || name === 'null') {
            return false;
        }

        this.showExpirationIdentifier(option);

        return true;
    }

    private filterMaquinariaOption(
        option: FilteredValue<MaquinariaModel>,
        context?: DropdownFilterContext<MaquinariaModel>,
    ): boolean {
        return createClientScopedCatalogueLegacyFilter<MaquinariaModel>({
            activeFieldName: 'activo',
            activeValue: '1',
            requireActive: true,
            isEnabled: () => this.env.appName === 'pyf',
            getClientId: (filterContext) => this.resolveCatalogueClientId(filterContext ?? context),
            onAccepted: (acceptedOption) => this.showExpirationIdentifier(acceptedOption),
        })(option, context) === true;
    }

    private resolveCatalogueClientId<TEntity>(context: DropdownFilterContext<TEntity> | undefined): unknown {
        const explicitClient = context?.model?.get('id_cliente')?.value;
        const explicitClientId = this.getObjectProperty(explicitClient, 'id') ?? explicitClient;

        if (explicitClientId !== null && explicitClientId !== undefined && explicitClientId !== '') {
            return explicitClientId;
        }

        return this.resolveClientId(context?.model?.get('id_finca')?.value);
    }

    private resolveMaquinariaFromWorkers(workersValue: unknown, currentValue: unknown, allowMultiple: boolean): unknown {
        if (this.hasMeaningfulValue(currentValue)) {
            return undefined;
        }

        const workerIds = new Set(
            this.resolveDropdownRawValues(this.lists.trabajadores, workersValue)
                .map((worker) => this.getObjectProperty(worker, 'id_maquina'))
                .filter((id): id is string | number => typeof id === 'string' || typeof id === 'number')
                .map(String),
        );

        if (workerIds.size === 0) {
            return undefined;
        }

        const maquinaria = (this.lists.maquinarias.values ?? [])
            .map((option) => option.raw ?? option.value)
            .filter((value): value is MaquinariaModel => typeof value === 'object' && value !== null)
            .filter((value) => value.id !== undefined && workerIds.has(String(value.id)))
            .sort((left, right) => (left.nombre ?? '').localeCompare(right.nombre ?? ''));

        if (maquinaria.length === 0) {
            return undefined;
        }

        return allowMultiple ? maquinaria : maquinaria[0];
    }


    private resolveTrabajadorFromMaquinaria(maquinariaValue: unknown, currentValue: unknown): unknown {
        if (this.hasMeaningfulValue(currentValue)) {
            return undefined;
        }

        if (this.env.showTareasMto && this.formType === FormType.CREATION) {
            const userInfo = StorageManager.getUser();

            if (userInfo.rol === 'user') {
                return this.findTrabajadorById(userInfo.id);
            }
        }

        const maquinaria = this.findDropdownRawValue(
            this.lists.maquinarias,
            maquinariaValue || this.getModelTextValue('id_maquinaria'),
        ) as Partial<MaquinariaModel> | null;
        const maquinariaId = maquinaria?.id ?? maquinariaValue ?? this.getModelTextValue('id_maquinaria');

        if (maquinariaId === null || maquinariaId === undefined || maquinariaId === '') {
            return undefined;
        }

        return (this.lists.trabajadores.values ?? [])
            .map((option) => option.raw ?? option.value)
            .find((trabajador) => this.valuesMatch(this.getObjectProperty(trabajador, 'id_maquina'), maquinariaId));
    }

    private findTrabajadorById(trabajadorId: unknown): unknown {
        return (this.lists.trabajadores.values ?? [])
            .map((option) => option.raw ?? option.value)
            .find((trabajador) => this.valuesMatch(this.getObjectProperty(trabajador, 'id'), trabajadorId));
    }

    private hasMeaningfulValue(value: unknown): boolean {
        if (value === null || value === undefined || value === '') {
            return false;
        }

        if (Array.isArray(value)) {
            return value.length > 0;
        }

        return true;
    }



    /** Resolve the current client id from the selected finca without depending on DropdownData.selected. */
    private resolveClientId(fincaValue: unknown): unknown {
        const clientId = this.cliente?.id ??
            this.resolveFincaProperty(fincaValue, 'id_cliente') ??
            this.getModelTextValue('id_cliente');

        return clientId === '' ? undefined : clientId;
    }

    /** Resolve the current user id from the selected finca without depending on DropdownData.selected. */
    private resolveUserId(fincaValue: unknown): unknown {
        if (!this.env.showTareasMto) {
            const userId = this.usuario?.id ??
                this.resolveFincaProperty(fincaValue, 'id_usuario') ??
                this.getModelTextValue('id_usuario');

            return userId === '' ? undefined : userId;
        }

        if (this.formType !== FormType.EDITION) {
            return this.usuario?.id;
        }

        const storedUserId = this.getModelTextValue('id_usuario');

        return storedUserId === '' ? undefined : storedUserId;
    }

    /** Resolve a finca property from either the current control value or the option catalog. */
    private resolveFincaProperty(fincaValue: unknown, propertyName: keyof FincasModel): unknown {
        const directValue = this.getObjectProperty(fincaValue, String(propertyName));

        if (directValue !== null && directValue !== undefined && directValue !== '') {
            return directValue;
        }

        return this.getObjectProperty(
            this.findDropdownRawValue(this.lists.fincas, fincaValue),
            String(propertyName),
        );
    }

    /** Keep stored hidden values while dropdown options are still loading. */
    private getModelTextValue(fieldName: string): string {
        const value = (this.model as Record<string, unknown>)[fieldName];

        if (value === null || value === undefined) {
            return '';
        }

        if (Array.isArray(value)) {
            return value.map(String).join(';');
        }

        return value.toString();
    }

    private calculateLitrosAplicadosHa(superficieValue: unknown, litrosAplicadosValue: unknown): string {
        const superficie = Number.parseFloat(String(superficieValue ?? '0').replace(',', '.')) || 0;
        const litrosAplicados = Number.parseFloat(String(litrosAplicadosValue ?? '0').replace(',', '.')) || 0;

        if (superficie <= 0 || litrosAplicados <= 0) {
            return '0';
        }

        return String(+Utils.decimalFormat(litrosAplicados / superficie));
    }


    /** Build semicolon-separated hidden values from the current FormGroup value first. */
    private joinParcelasFieldFromValue(selectedValue: unknown, fieldName: keyof ParcelasModel, fallbackFieldName: string): string {
        const selectedParcelas = this.resolveDropdownRawValues(this.lists.parcelas, selectedValue);

        if (selectedParcelas.length === 0) {
            return this.getModelTextValue(fallbackFieldName);
        }

        return selectedParcelas
            .map((parcela) => this.getObjectProperty(parcela, String(fieldName)))
            .filter((value) => value !== null && value !== undefined && value !== '')
            .map(String)
            .join(';');
    }

    /** Resolve one or multiple dropdown raw entities from primitive or object control values. */
    private resolveDropdownRawValues(
        dropdownData: { values?: Array<{ value?: unknown; raw?: unknown; valueAliases?: readonly unknown[] }> },
        selectedValue: unknown,
    ): unknown[] {
        const selectedValues = this.normalizeSelectedValues(selectedValue);

        return selectedValues
            .map((value) => this.findDropdownRawValue(dropdownData, value) ?? value)
            .filter((value) => typeof value === 'object' && value !== null);
    }

    private normalizeSelectedValues(selectedValue: unknown): unknown[] {
        if (Array.isArray(selectedValue)) {
            return selectedValue;
        }

        if (typeof selectedValue === 'string' && selectedValue.includes(';')) {
            return selectedValue
                .split(';')
                .map((value) => value.trim())
                .filter((value) => value.length > 0);
        }

        return [selectedValue];
    }

    /** Resolve the raw option entity without reading mutable selected state. */
    private findDropdownRawValue(
        dropdownData: { values?: Array<{ value?: unknown; raw?: unknown; valueAliases?: readonly unknown[] }> },
        selectedValue: unknown,
    ): unknown {
        if (selectedValue === null || selectedValue === undefined || selectedValue === '') {
            return null;
        }

        if (typeof selectedValue === 'object') {
            return selectedValue;
        }

        const matchedOption = dropdownData.values?.find((option) => this.matchesDropdownOption(selectedValue, option));

        return matchedOption?.raw ?? matchedOption?.value ?? null;
    }

    /** Match primitive control values against canonical value, aliases and raw entity id. */
    private matchesDropdownOption(
        selectedValue: unknown,
        option: { value?: unknown; raw?: unknown; valueAliases?: readonly unknown[] },
    ): boolean {
        return this.valuesMatch(selectedValue, option.value) ||
            this.valuesMatch(selectedValue, this.getObjectProperty(option.raw, 'id')) ||
            (option.valueAliases ?? []).some((alias) => this.valuesMatch(selectedValue, alias));
    }

    /** Read a property from unknown raw entities safely. */
    private getObjectProperty(value: unknown, propertyName: string): unknown {
        if (typeof value !== 'object' || value === null) {
            return null;
        }

        return (value as Record<string, unknown>)[propertyName] ?? null;
    }

    /** Compare dropdown ids consistently when some catalogs use numeric ids and others strings. */
    private valuesMatch(left: unknown, right: unknown): boolean {
        if (left === null || left === undefined || right === null || right === undefined) {
            return false;
        }

        return left === right || String(left) === String(right);
    }


    /** Coerce a value to a finite number; returns 0 if not numeric. */
    public toFiniteNumber(v: unknown): number {
        if (typeof v === 'number') {return Number.isFinite(v) ? v : 0;}
        if (typeof v === 'string') {
            const s = v.trim();

            if (s === '' || /^(?:NaN|undefined|null)$/i.test(s)) {return 0;}
            // remove thousand separators and normalize decimal comma
            const cleaned = s.replace(/\s/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(/,/, '.');
            const n = Number(cleaned);

            return Number.isFinite(n) ? n : 0;
        }
    return 0;
    }

}
